import { ADD_TO_CART_ERROR, ADD_TO_CART_REQUEST, ADD_TO_CART_SUCCESS, CART_QUANTITY_CHANGED, DECAL_EDITOR_SETTINGS_LOAD_ERROR, DECAL_EDITOR_SETTINGS_RECEIVE, LOAD_SIGN_FOR_EDIT_REQUEST, LOAD_SIGN_FOR_EDIT_SUCCESS, LOAD_SIGN_FOR_EDIT_ERROR, CANCEL_SIGN_EDITING, UPLOADED_IMAGES, CART_IMAGES, LOAD_E_SIGN_EDITOR_TEMPLATE_SUCCESS, EDITOR_TEMPLATE_MODIFIED, DELETE_TEMPLATE_SUCCESS, LOAD_TEMPLATES_SUCCESS, LOAD_TEMPLATES_REQUEST, LOAD_TEMPLATE_SUCCESS, LOAD_TEMPLATE_REQUEST, DISCARD_TEMPLATE, DECAL_ICONS_RECEIVE, } from '../../Rutab/RutabConstants';
const initialState = {
    settings: null,
    decalTemplateCategories: [],
    decalIconCategories: [],
    decalIcons: [],
    loadingSettings: false,
    settingsError: null,
    addingToCart: false,
    cartError: null,
    cartResult: null,
    cartQuantity: 1,
    loadingSignForEdit: false,
    signForEdit: null,
    signForEditError: null,
    uploadedImages: [],
    cartImages: [],
    productTemplate: null,
    productTemplateModified: false,
    templates: [],
    loadingTemplates: true,
    selectedTemplate: null,
    loadingSelectedTemplate: {
        isLoading: false,
        templateId: null,
    },
};
export const decalEditorAPI = (state = initialState, action) => {
    var _a, _b;
    switch (action.type) {
        case DECAL_EDITOR_SETTINGS_RECEIVE:
            return Object.assign(Object.assign({}, state), { settings: action.payload.settings, decalTemplateCategories: (_a = action.payload.settings) === null || _a === void 0 ? void 0 : _a.decalTemplateCategories, decalIconCategories: (_b = action.payload.settings) === null || _b === void 0 ? void 0 : _b.decalIconCategories, loadingSettings: false, settingsError: null });
        case DECAL_ICONS_RECEIVE:
            return Object.assign(Object.assign({}, state), { decalIcons: action.payload.decalIcons });
        case DECAL_EDITOR_SETTINGS_LOAD_ERROR:
            return Object.assign(Object.assign({}, state), { loadingSettings: false, settingsError: action.payload.error });
        case ADD_TO_CART_REQUEST:
            return Object.assign(Object.assign({}, state), { addingToCart: true, cartError: null });
        case ADD_TO_CART_SUCCESS:
            return Object.assign(Object.assign({}, state), { addingToCart: false, cartResult: action.payload.result, cartError: null, signForEditError: null, signForEdit: null, uploadedImages: [], cartQuantity: 1 });
        case ADD_TO_CART_ERROR:
            return Object.assign(Object.assign({}, state), { addingToCart: false, cartError: action.payload.error });
        case CART_QUANTITY_CHANGED:
            return Object.assign(Object.assign({}, state), { cartQuantity: action.payload.cartQuantity });
        case LOAD_SIGN_FOR_EDIT_REQUEST:
            return Object.assign(Object.assign({}, state), { loadingSignForEdit: action.payload.isLoading, signForEditError: null });
        case LOAD_SIGN_FOR_EDIT_SUCCESS:
            return Object.assign(Object.assign({}, state), { signForEdit: action.payload.sign, signForEditError: null });
        case LOAD_SIGN_FOR_EDIT_ERROR:
            return Object.assign(Object.assign({}, state), { loadingSignForEdit: false, signForEditError: action.payload.error });
        case CANCEL_SIGN_EDITING:
            return Object.assign(Object.assign({}, state), { loadingSignForEdit: false, signForEdit: null, signForEditError: null, cartQuantity: 1, uploadedImages: [] });
        case UPLOADED_IMAGES:
            return Object.assign(Object.assign({}, state), { uploadedImages: action.payload.uploadedImages });
        case CART_IMAGES:
            return Object.assign(Object.assign({}, state), { cartImages: action.payload.images });
        case LOAD_E_SIGN_EDITOR_TEMPLATE_SUCCESS:
            return Object.assign(Object.assign({}, state), { productTemplate: action.payload.template, productTemplateModified: false });
        case EDITOR_TEMPLATE_MODIFIED:
            return Object.assign(Object.assign({}, state), { productTemplateModified: true });
        case LOAD_TEMPLATES_REQUEST:
            return Object.assign(Object.assign({}, state), { loadingTemplates: action.payload.isLoading });
        case LOAD_TEMPLATES_SUCCESS:
            return Object.assign(Object.assign({}, state), { templates: action.payload.templates, loadingTemplates: false });
        case LOAD_TEMPLATE_REQUEST:
            return Object.assign(Object.assign({}, state), { loadingSelectedTemplate: {
                    templateId: action.payload.templateId,
                    isLoading: action.payload.isLoading,
                } });
        case LOAD_TEMPLATE_SUCCESS:
            return Object.assign(Object.assign({}, state), { selectedTemplate: action.payload.template });
        case DISCARD_TEMPLATE:
            return Object.assign(Object.assign({}, state), { selectedTemplate: null });
        case DELETE_TEMPLATE_SUCCESS: {
            const templatesObj = state.templates;
            return Object.assign(Object.assign({}, state), { templates: Object.assign(Object.assign({}, templatesObj), { customerItems: (templatesObj.customerItems || []).filter((t) => t.templateId !== action.payload.templateId) }), selectedTemplate: state.selectedTemplate && state.selectedTemplate.templateId === action.payload.templateId
                    ? null
                    : state.selectedTemplate });
        }
        default:
            return state;
    }
};
